export default "__VITE_ASSET__e89d15e3__"